import { CREATION_FORCES } from "../modules/reports/shared/content/creationForces";

console.log("custom data loaded");

export const numMeanings = [
  "hartsverlangen",
  "verbinding",
  "communiceren (tov groep)",
  "creativiteit & balans",
  "bouwen & spelen",
  "helderheid & begrip",
  "levensenergie",
  "Ergens doorheen gaan",
  "dienstbaarheid",
  "leiderschap",
  "meesterschap",
  "afronden",
];
export const denken = [
  "Je mag vertrouwen op ingevingen of ideeën met hartsverlangen",
  "Jij wil je denken graag verbinden met anderen",
  "Deel je ideeën en gedachten in jou met een groep",
  "Jouw creatieve ideeën beginnen met chaos en structuur",
  "Jouw gedachten en ideeën zijn ondernemend",
  "Jij hebt blijkbaar de meest heldere ingevingen",
  "Laat magische ingevingen uit het donker verschijnen",
  "Doorbrekende en helende gedachten bevinden zich in je hoofd",
  "Zorg dat je ingevingen dienstbaar zijn aan jezelf",
  "Je mag leiding nemen over je ingevingen & ideeën",
  "Kennis komt jou als vanzelf aanwaaien",
  "Jij kan voor afronding zorgen van ideeën",
];
export const doen = [
  "Als je je hartsveralngen volgt, zul je veel voor elkaar krijgen",
  "Als je samenwerkt krijg je dingen voor elkaar",
  "Deel wat in je leeft als je iest in of met een groep aan het doen bent",
  "Jij hebt een artistieke gave",
  "Lekker spelen en bouwen is voor jou niet vreemd",
  "De 6 brengt helderheid in praktische situaties",
  "Jij hebt vaak meer energie dan anderen als een duracell batterij",
  "jij hebt de actiekracht om te lijmen en te helen",
  "Alles wat je doet mag dienstbaar zijn aan jezelf",
  "Neem de leiding over de uitvoering van jouw creatieproces",
  "Jij vindt het leuk om anderen les te geven of kennis tot je te nemen",
  "Hop, klaar volgend project! Afronden is jouw ding",
];
export const voelen = [
  "Mag er van jou gehouden worden?",
  "Verbinding met de ander is het liefste wat je wil, maar ook het moeilijkst",
  "Je knieen bibberen om in een groep te delen wat er in je omgaat, maar dat is ok",
  "Jij bent een geboren kunstenaar en creator, nu zelf nog geloven",
  "Passief zijn is soms ook belangrijk",
  "Omarm de twijfel over je intuïtie en kennis",
  "Magische en depressieve gevoelens zijn niet vreemd voor jou",
  "jij blijft het spannend vinden om dingen te doorbreken",
  "Jij bent een geboren dienaar (van jezelf)",
  "Het gevoel van twijfel over leiderschap hoort erbij",
  "Jij bent geboren als leraar, jij belichaamd kennis",
  "Snel afraffelen of niet aan beginnen? Het is ok",
];
export const zijn = [
  "Jij vindt het fijn om gewoon te zijn met hartsverbinding",
  "Jij wil graag Samen zijn in verbinding met de ander",
  "Je bevindt je graag in een groep waar het veilig voelt",
  "Het liefst woon of hang je uit in een creatieve omgeving",
  "Een 'speeltuin' kent geen geheimen voor jou",
  "Je vertoeft graag in een spirituele leer- en leefomgeving",
  "Als jij aanwezig bent, kan er magie ontstaan",
  "Jouw aanwezigheid zorgt voor heling",
  "Dienstbaar zijn voor jezelf en anderen is jouw pad",
  "Mensen zijn graag bij je met jouw leiderschap",
  "Jij geniet ervan om in een klaslokaal of leeromgeving volledig aanwezig te zijn",
  "Jij kunt helemaal genieten van een afgerond project of proces",
];
export const hart = [
  "Jouw hart gaat kloppen van iemand met passie",
  "Jouw hart gaat kloppen van iemand die verbindt",
  "Jouw hart gaat kloppen van iemand die deelt wat er in hem of haar leeft",
  "Jouw hart gaat kloppen van iemand die creatief is",
  "Jouw hart gaat kloppen van iemand die speels en ondernemend is",
  "Jouw hart gaat kloppen van iemand die helderheid brengt",
  "Jouw hart gaat kloppen van iemand met energie",
  "Jouw hart gaat kloppen van iemand met helende of doorbrekende kwaliteiten",
  "Jouw hart gaat kloppen van iemand die dienstbaar is",
  "Jouw hart gaat kloppen van iemand die leiding neemt",
  "Jouw hart gaat kloppen van iemand die veel kennis heeft",
  "Jouw hart gaat kloppen van iemand die kan afronden",
];
export const scheppingsKrachten = CREATION_FORCES;

export const elements = [
  {
    name: "denken",
    element: "lucht",
    icon: "air",
    windrichting: "noord",
    wiel: "levensdoel",
  },
  {
    name: "doen",
    element: "vuur",
    icon: "whatshot",
    windrichting: "oost",
    wiel: "gave/talent",
  },
  {
    name: "voelen",
    element: "water",
    icon: "water",
    windrichting: "zuid",
    wiel: "karma",
  },
  {
    name: "zijn",
    element: "aarde",
    icon: "terrain",
    windrichting: "west",
    wiel: "levenspad",
  },
  {
    name: "hart",
    element: "hart",
    icon: "favorite",
    windrichting: "hart",
    wiel: "zielstrilling",
  },
];
